// Mark: a turn coordinator in wings-level, coordinated flight — the miniature
// airplane's wings point into the gaps in the bezel, and the ball sits centred
// in its tube.
export function LogoMark({ size = 28, className = '' }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M29.93 18.21A14.1 14.1 0 0 1 2.07 18.21M2.07 13.79A14.1 14.1 0 0 1 29.93 13.79" strokeWidth="2" />
      <path d="M6.8 16h18.4M16 13.3V9.6" />
      <circle cx="16" cy="16" r="2.7" fill="currentColor" stroke="none" />
      <path d="M10.7 23.75a12 12 0 0 0 10.6 0" strokeWidth="3" strokeOpacity="0.28" />
      <circle cx="16" cy="25" r="1.8" fill="currentColor" stroke="none" />
    </svg>
  );
}

export default function Logo({ className = '' }) {
  return (
    <span className={`logo ${className}`}>
      <LogoMark />
      <span className="logo__word">Average Quality</span>
    </span>
  );
}
